import { IonSpinner } from '@ionic/react';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { GrapeButton } from '..';
import { Hideable } from '../../hideable';
export function DropAreaText(props) {
    // CONSTANT DECLARATION
    const { buttonText, children, dropZoneInactive = false, imageCount, multiple = false, uploading = false } = props;
    if (!dropZoneInactive) {
        if (children) {
            return children;
        }
        return React.createElement("p", null,
            "Drop your file here ",
            React.createElement(FontAwesome, { name: "upload" }));
    }
    if (!imageCount) {
        return React.createElement(GrapeButton, { disabled: !!uploading, type: "button" },
            React.createElement(FontAwesome, { name: "upload" }),
            React.createElement(Hideable, { hide: !uploading },
                React.createElement(IonSpinner, null)),
            buttonText ? buttonText : `Upload${multiple ? 'Files' : 'File'}`);
    }
    return React.createElement("p", null,
        "Current ",
        multiple ? 'Images' : 'Image',
        " Uploaded:");
}
//# sourceMappingURL=dropAreaText.js.map